<script setup lang="ts">

import GFBSSpies from '@/components/Sections/Government/Finances/BalanceSheetDetails/Spies/GFBSSpies.vue'
</script>

<template>
  <GFBSSpies/>
</template>

<style scoped lang="scss">

</style>